module.exports = __webpack_public_path__ + "static/media/9.Demolition Hammer 11E.4b9567f7.jpg";